/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editdealform_Internaluseonly5Inputs */

const en_coinvestments_editdealform_internaluseonly5 = /** @type {(inputs: Coinvestments_Editdealform_Internaluseonly5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal use only`)
};

/**
* | output |
* | --- |
* | "Internal use only" |
*
* @param {Coinvestments_Editdealform_Internaluseonly5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editdealform_internaluseonly5 = /** @type {((inputs?: Coinvestments_Editdealform_Internaluseonly5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editdealform_Internaluseonly5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editdealform_internaluseonly5(inputs)
});
export { coinvestments_editdealform_internaluseonly5 as "coInvestments_editDealForm_internalUseOnly" }